export default {
  // Navigation
  'nav.about': 'О нас',
  'nav.services': 'Услуги',
  'nav.approach': 'Наш подход',
  'nav.cases': 'Кейсы',
  'nav.team': 'Команда',
  'nav.contacts': 'Контакты',
  
  // Hero Section
  'hero.title': 'Системный маркетинг и Искусственный Интеллект: Ваш ключ к стабильному росту продаж',
  'hero.subtitle': 'Превращаем хаос в систему. Объединяем экспертный опыт с точностью AI-алгоритмов, чтобы масштабировать ваш бизнес.',
  'hero.cta1': 'Получить стратегию роста',
  'hero.cta2': 'Обсудить проект',
  'hero.formTitle': 'Ваш маркетинг работает на 100% или сливает бюджет?',
  'hero.formSubtitle': 'Не гадайте. Получите честный взгляд со стороны. Запишитесь на бесплатную 20-минутную экспресс-диагностику вашего проекта.',
  'hero.formBenefitsTitle': 'Что вы узнаете:',
  'hero.formBenefit1': 'Где вы теряете клиентов прямо сейчас (поиск «дыр» в воронке)',
  'hero.formBenefit2': '3 неочевидные точки роста для масштабирования выручки',
  'hero.formBenefit3': 'Как ИИ может снизить ваши расходы на рекламу',
  'hero.formName': 'Имя',
  'hero.formPhone': 'Телефон',
  'hero.formWebsite': 'Ссылка на сайт',
  'hero.formWebsiteOptional': '(необязательно)',
  'hero.formSubmit': 'Получить стратегию роста',
  'hero.formPrivacy': 'Нажимая на кнопку, я даю согласие на обработку персональных данных и соглашаюсь с политикой конфиденциальности',
  'hero.formSuccess': 'Заявка отправлена! Мы свяжемся с вами в ближайшее время.',
  'hero.formError': 'Произошла ошибка. Попробуйте еще раз.',
  
  // Pain Points
  'pain.title': 'Знакомая ситуация?',
  'pain.point1.title': 'Точечно нанимаете фрилансеров',
  'pain.point1.desc': 'И ждете чуда, которое так и не происходит?',
  'pain.point2.title': 'Сливаете бюджеты',
  'pain.point2.desc': 'В Яндекс и Google без видимого результата?',
  'pain.point3.title': 'Есть ощущение',
  'pain.point3.desc': '«Я что-то делаю не так», но нет понимания, как исправить?',
  'pain.conclusion': 'Хаотичные действия без системы приводят только к потере времени и денег',
  
  // Solution
  'solution.title': 'Что такое системный маркетинг?',
  'solution.subtitle': 'Ваш ключ к стабильному росту и продажам',
  'solution.problemTitle': 'Маркетинговый хаос — враг вашей прибыли',
  'solution.problemDesc': 'Большинство компаний живут в состоянии «маркетингового хаоса»: точечные запуски рекламы, смена подрядчиков, отсутствие понимания, какой рубль принес прибыль, а какой был слит впустую.',
  'solution.defTitle': 'Системный маркетинг — это противоположность хаосу',
  'solution.defDesc1': 'Это подход, при котором маркетинг рассматривается не как набор разрозненных действий (запустили Директ, написали пост), а как единый организм, работающий на предсказуемый финансовый результат.',
  'solution.defDesc2': 'Это фундамент, благодаря которому клики превращаются в реальных, лояльных клиентов, а каждый вложенный рубль приносит измеримую прибыль.',
  'solution.pillarsTitle': 'Три кита системного маркетинга',
  'solution.pillarsSubtitle': 'Единство трех элементов',
  'solution.pillarsDesc': 'Системный маркетинг держится на синергии трех ключевых компонентов, которые работают как единый механизм',
  
  // Services
  'services.title': 'Наши Услуги',
  'services.subtitle': 'Выберите готовое решение или создадим индивидуальную стратегию под ваш бизнес',
  'services.cta': 'Рассчитать стоимость услуг',
  
  // How We Work
  'howWeWork.title': 'Как мы работаем',
  'howWeWork.subtitle': '5 этапов построения системы — пошаговый процесс трансформации вашего маркетинга',
  
  // Case Studies
  'cases.title': '💼 Кейсы: Как работает система на практике',
  'cases.subtitle': 'Мы не скрываем результаты. Вот примеры того, как внедрение стратегии и сквозной аналитики влияет на выручку в реальном времени.',
  
  // Why Us
  'whyUs.title': 'Почему мы?',
  'whyUs.subtitle': 'Мы — ваш стратегический партнер, а не просто подрядчик',
  'whyUs.reason1.title': 'Гарантия на базе ИИ',
  'whyUs.reason1.desc': 'Базируем расходы на точных моделях, а не догадках. Искусственный интеллект анализирует миллионы данных для принятия оптимальных решений.',
  'whyUs.reason2.title': 'Секретное оружие',
  'whyUs.reason2.desc': 'Технологии, которых нет у ваших конкурентов. Мы используем передовые AI-инструменты для прогнозирования и автоматизации.',
  'whyUs.reason3.title': 'Ваше время — ценность',
  'whyUs.reason3.desc': 'Мы берем рутину на себя, вы занимаетесь бизнесом. Полная автоматизация процессов освобождает ваши ресурсы для стратегического развития.',
  
  // Results
  'results.title': 'Что вы получите после внедрения системы?',
  'results.subtitle': 'Конкретные результаты, которые изменят ваш бизнес',
  
  // About
  'about.title': 'Эволюция от Топ-эксперта до Основателя',
  'about.subtitle': 'Мы не верим в интуитивный маркетинг. Мы верим в точность данных, глубину психологии и скорость алгоритмов.',
  
  // Lead Form
  'leadForm.title': 'Готовы превратить хаос в стабильный рост?',
  'leadForm.subtitle': 'Оставьте заявку на бесплатную диагностику вашего маркетинга. Мы покажем точки роста с помощью ИИ-анализа.',
  'leadForm.name': 'Ваше имя',
  'leadForm.phone': 'Телефон',
  'leadForm.website': 'Сайт',
  'leadForm.websiteOptional': '(необязательно)',
  'leadForm.messenger': 'Предпочитаемый мессенджер',
  'leadForm.messengerPlaceholder': 'Выберите мессенджер',
  'leadForm.telegram': 'Telegram',
  'leadForm.whatsapp': 'WhatsApp',
  'leadForm.phoneCall': 'Телефонный звонок',
  'leadForm.submit': 'Записаться на диагностику',
  'leadForm.success': '✓ Заявка отправлена! Мы свяжемся с вами в ближайшее время.',
  'leadForm.error': 'Произошла ошибка. Попробуйте еще раз.',
  'leadForm.privacy': 'Нажимая на кнопку, я даю согласие на обработку персональных данных и соглашаюсь с политикой конфиденциальности',
  
  // Footer
  'footer.company': 'Системный Маркетинг',
  'footer.description': 'Превращаем хаос в систему. Объединяем экспертный опыт с точностью AI-алгоритмов.',
  'footer.services': 'Услуги',
  'footer.company.title': 'Компания',
  'footer.contacts': 'Контакты',
  'footer.address': '109202, Москва, ул 2-я Карачаровская, д. 1 стр. 1, помещ. 6/2',
  'footer.rights': 'Системный Маркетинг. Все права защищены.',
  'footer.privacy': 'Политика конфиденциальности',
  'footer.terms': 'Пользовательское соглашение',
  
  // Common
  'common.readMore': 'Читать далее',
  'common.contactUs': 'Связаться с нами',
  'common.learnMore': 'Узнать больше',
  'common.loading': 'Загрузка...',
  'common.submit': 'Отправить',
  'common.cancel': 'Отменить',
  'common.close': 'Закрыть',
};
